/**
 * (PC) pc.pping 페이지 중단에
 * 좌측 플로팅 카테고리 아이콘 모음 컴포넌트
 */

import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
// import { scrollTo } from 'estimate_list/libs/util'

const ICON = {
    '1010000000': { name: 'buttn', size: 2.17 },
    '1490000000': { name: 'monitor', size: 1.86 },
    '1500000000': { name: 'hard', size: 2.39 },
    '1020000000': { name: 'wifi', size: 2.34 },
    '1030000000': { name: 'file', size: 2.48 },
    '1450000000': { name: 'mic', size: 2.4 },
    '1550000000': { name: 'print1', size: 1.9 },
}
const START_FIX = 100

const SubNav = (props) => {
    const { selectCategory, minishopInfo } = useSelector((state) => state.initial)
    const categoryData = useSelector((state) => state.category.categoryData)
    const currentCategory = useSelector((state) => state.category.currentCategory)
    const [list, setList] = useState([])
    const [fixMode, setfixMode] = useState(false)
    const [underFix, setUnderFix] = useState(false)
    const [limitSize, setLimitSize] = useState(false)

    const isMinishop = minishopInfo
    const minishopId = isMinishop ? `/${minishopInfo.mall_web_user}` : ''

    const nav = useRef(null)
    const elTargetParent = document.querySelector('#layout_list_group')
    const elTargetNavSpy = document.querySelector('#nav_spy')

    useEffect(() => {
        setFdiv0List()
    }, []) // eslint-disable-line

    useEffect(() => {
        window.addEventListener('scroll', scroll)
        window.addEventListener('resize', resize)
        return () => {
            window.removeEventListener('scroll', scroll)
            window.removeEventListener('resize', resize)
        }
    }, []) // eslint-disable-line

    const setFdiv0List = () => {
        const cateData = [...categoryData]
        const findIndex = cateData.findIndex((v) => v.cate_id === '0000000102') // 컴퓨터·노트북·모바일
        const depth1 = cateData[findIndex].child
        const fdiv0List = depth1.filter((v) => v.f_div === 0)
        setList(fdiv0List)
    }

    const scroll = () => {
        const elTargetParentTop = elTargetParent.getBoundingClientRect()
        const elTargetNavSpyRect = elTargetNavSpy.getBoundingClientRect()
        const elTargetNavSpyRectHeight = elTargetNavSpyRect.height
        const elTargetNavSpyRectTop = elTargetNavSpyRect.top
        const navOffsetHeight = nav.current?.offsetHeight || 370

        if (elTargetParentTop.top - START_FIX <= 0) {
            if (elTargetNavSpyRectHeight + elTargetNavSpyRectTop - START_FIX <= navOffsetHeight) {
                setfixMode(false) // absolute 리스트 하단 고정
                setUnderFix(elTargetNavSpyRectHeight - navOffsetHeight + START_FIX - 71)
            } else {
                setfixMode(true) // fix 스크롤 콘텐츠 안
                setUnderFix(false)
            }
        } else {
            setfixMode(false) //absolute 스크롤 상단
            setUnderFix(false)
        }
    }

    const resize = () => {
        if (document.body.offsetWidth <= 950) {
            setLimitSize(true)
        } else {
            setLimitSize(false)
        }
    }

    /**
     * 서브 메뉴에서 카테고리 선택 시 스크롤을 최상단으로 움직이는 함수
     */

    const goListTop = () => {
        props.setIsScroll(true)
        // console.log('😊서브메뉴클릭')

        // const element = document.getElementById("layout_list_group");
        // element.scrollIntoView({behavior: "smooth", block:"center"});
    }


    return (
        <>
            {list.length > 0 && currentCategory?.cate?.length > 0 && (
                <Style fixMode={fixMode} ref={nav} underFix={underFix} limitSize={limitSize}>
                    <ul className="depth_1">
                        {list.map((v) => (
                            <li
                                key={v.cate_id}
                                className={`depth_1_menu ${
                                    selectCategory && selectCategory.substr(0, 3) === v.cate_id.toString().substr(0, 3)
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                {v?.f_clk ? (
                                    <Link to={`${minishopId}/list/${v.cate_id}${window.location.search}`} onClick={goListTop}>
                                        <IconMenu
                                            className={`icon_menu icon-${ICON[v.cate_id]?.name || 'new-1'}`}
                                            size={ICON[v.cate_id]?.size || 1.8}
                                        />
                                    </Link>
                                ) : (
                                    <IconMenu
                                        className={`icon_menu icon-${ICON[v.cate_id]?.name || 'new-1'}`}
                                        size={ICON[v.cate_id]?.size || 1.8}
                                    />
                                )}
                                <span className="sound_only">{v.cate_name}</span>
                                {v?.child?.length > 0 && (
                                    <div className="layer last_shadow">
                                        <div className="title">{v.cate_name}</div>
                                        <ul className="menu_group">
                                            {v.child.map((sub) => {
                                                return (
                                                    <li
                                                        key={sub.cate_id}
                                                        className={`${
                                                            currentCategory.reduce.cate2 === sub.cate_id ? 'active' : ''
                                                        }`}
                                                    >
                                                        <Link
                                                            to={`${minishopId}/list/${sub.cate_id}${window.location.search}`}
                                                            onClick={goListTop}
                                                            className={sub.child.length > 0 ? 'is_child' : ''}
                                                        >
                                                            {sub.cate_name}
                                                        </Link>
                                                        {sub.child.length > 0 && (
                                                            <SubChild
                                                                sub={sub}
                                                                dep={2}
                                                                minishopId={minishopId}
                                                                currentCategory={currentCategory}
                                                                goListTop={goListTop}
                                                            />
                                                        )}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </Style>
            )}
        </>
    )
}

const SubChild = ({ sub, dep, minishopId, currentCategory, goListTop }) => {
    return (
        <ul className={`menu_group_sub sub${dep} last_shadow`}>
            {sub.child.map((sub2) => {
                return(
                    <React.Fragment key={sub2.cate_id}>
                        <li className={`${currentCategory.reduce['cate' + (dep + 1)] === sub2.cate_id ? 'active' : ''}`}>
                            <Link
                                to={`${minishopId}/list/${sub2.cate_id}${window.location.search}`}
                                onClick={goListTop}
                                className={sub2.child.length > 0 ? 'is_child' : ''}
                            >
                                {sub2.cate_name}
                            </Link>
                            {sub2.child.length > 0 && (
                                <SubChild
                                    sub={sub2}
                                    dep={3}
                                    minishopId={minishopId}
                                    currentCategory={currentCategory}
                                    goListTop={goListTop}
                                />
                            )}
                        </li>
                    </React.Fragment>
                )
            })}
        </ul>
    )
}

const Style = styled.div`
    position: ${(props) => (props.fixMode ? 'fixed' : 'absolute')};
    top: ${(props) => (props.underFix ? props.underFix : props.fixMode ? START_FIX : 0)}px;
    left: ${(props) => (props.fixMode ? 'calc(50% - 595px)' : 0)};
    width: 45px;
    z-index: 15;

    @media only screen and (max-width: 1209px) {
        left: ${(props) => (props.fixMode ? (props.limitSize ? 0 : 'calc(50% - 475px)') : 0)};
    }

    .sound_only {
        font-size: 0;
        text-indent: -9999px;
        display: none;
    }
    .depth_1:hover {
        .depth_1_menu.active .icon_menu {
            background: #fff;
            color: #969696;
        }
    }
    .depth_1_menu {
        border: 1px solid #c8c8c8;
        background: #fff;

        &.active {
            .icon_menu {
                background: #418ded;
                color: #fff;
            }
        }
        &:hover {
            .icon_menu {
                background: #418ded !important;
                color: #fff !important;
            }
            .layer {
                display: block;
            }
        }
        &:not(:first-child) {
            border-top: 0;
        }
        .last_shadow {
            box-shadow: 2px 2px 5px #0000001f;
        }
    }
    .layer {
        display: none;
        position: absolute;
        top: 0;
        left: 44px;
        min-width: 153px;
        min-height: 100%;
        border: 1px solid #418ded;
        background: #fff;

        .title {
            padding: 0 15px 0 0;
            height: 45px;
            line-height: 44px;
            text-indent: 25px;
            font-size: 13px;
            font-weight: 700;
            white-space: nowrap;
            color: #333;
            border-bottom: 1px solid #418ded;
        }
        .menu_group {
            margin: 10px 0 0;
            padding: 0 0 10px;

            &:hover {
                & > li > a {
                    color: #333 !important;
                }
            }
            li {
                &.active > a {
                    color: #418ded;
                }
                &:hover > a {
                    color: #418ded !important;

                    &:after {
                        opacity: 1 !important;
                    }
                }
                a {
                    position: relative;
                    display: block;
                    padding: 5px 25px;
                    color: #333;
                    font-size: 13px;
                    line-height: 19px;
                    white-space: nowrap;

                    &.is_child:after {
                        opacity: 0;
                        position: absolute;
                        font-size: 12px;
                        top: 6px;
                        right: 8px;
                        color: #418ded;
                        font-family: 'ppingkr_v4';
                        content: '\\e906';
                    }
                }
            }
        }
        .menu_group_sub {
            display: none;
            position: absolute;
            padding: 10px 0;
            border: 1px solid #418ded;
            left: 100%;
            background: #fff;
            min-width: 140px;

            &.sub2 {
                top: 44px;
                min-height: calc(100% - 43px);
            }
            &.sub3 {
                top: -1px;
                min-height: calc(100% + 1px);
            }
            &:hover {
                & > li > a {
                    color: #333 !important;
                }
            }
            li {
                &.active > a {
                    color: #418ded;
                }
                &:hover > a {
                    color: #418ded !important;
                }
            }
        }
        .menu_group li:hover {
            & > .menu_group_sub {
                display: block;
            }
        }
    }
`

const IconMenu = styled.i`
    display: block;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #969696;
    font-size: 10px;
    overflow: hidden;
    cursor: pointer;

    &:before {
        display: inline-block;
        transform: scale(${(props) => props.size});
    }
`

export default SubNav



// WEBPACK FOOTER //
// ./src/estimate_list/components/subnav/index.js